<template>
  <div class="row">
    <div class="col-12">
      <ibox
        :title="this.$t('nav.training-dates-list')"
        :collapseId="'collapse-2'"
      >
        <template slot="content" slot-scope="{ setLoading }">
          <TrainingCitiesForm @loading="setLoading" />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from "@/components/base/Ibox.vue";
import TrainingCitiesForm from "@/components/Courses/TrainingCitiesForm.vue";

export default {
  name: "TrainingCitiesDetails",
  components: {
    Ibox,
    TrainingCitiesForm
  },
  data() {
    return {
      excel: true
    };
  }
};
</script>
